import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { switchMap, map, catchError, of } from 'rxjs';
import {
  enrollMileagePlanMember,
  enrollMileagePlanMemberFailure,
  enrollMileagePlanMemberSuccess,
} from './mileage-plan-enrollment-service.actions';
import { MileagePlanEnrollmentService } from '../mileage-plan-enrollment.service';
import { HttpStatusCode } from '../../../dtos/http-status-code';
import { HttpErrorResponse } from '@angular/common/http';
import { MileagePlanEnrollmentStatus } from '../../../dtos/response/mileage-plan-response/mileage-plan-enrollment-status';

@Injectable()
export class MileagePlanEnrollmentServiceEffects {
  private readonly actions$ = inject(Actions);
  private readonly mileagePlanEnrollmentService = inject(MileagePlanEnrollmentService);

  enrollMileagePlanMember$ = createEffect(() =>
    this.actions$.pipe(
      ofType(enrollMileagePlanMember),
      switchMap((action) => {
        return this.mileagePlanEnrollmentService.enrollMPMember(action.mileagePlanEnrollmentRequest).pipe(
          map((mileagePlanEnrollmentResult) => {
            if (mileagePlanEnrollmentResult.statusCode === HttpStatusCode.CREATED) {
              mileagePlanEnrollmentResult.mileagePlanEnrollmentStatus = MileagePlanEnrollmentStatus.EXISTING_MEMBER;
              return enrollMileagePlanMemberSuccess(mileagePlanEnrollmentResult);
            } else if (mileagePlanEnrollmentResult.statusCode === HttpStatusCode.OK) {
              mileagePlanEnrollmentResult.mileagePlanEnrollmentStatus = MileagePlanEnrollmentStatus.SUCCESS;
              return enrollMileagePlanMemberSuccess(mileagePlanEnrollmentResult);
            }

            return enrollMileagePlanMemberFailure({
              statusCode: HttpStatusCode.INTERNAL_SERVER_ERROR,
              exceptionContent: 'Uncaught error',
              mileagePlanEnrollmentStatus: MileagePlanEnrollmentStatus.SYSTEM_FAILURE,
            });
          }),
          catchError((err: HttpErrorResponse) => {
            return of(
              enrollMileagePlanMemberFailure({
                statusCode: HttpStatusCode.INTERNAL_SERVER_ERROR,
                exceptionContent: err.message,
                mileagePlanEnrollmentStatus: MileagePlanEnrollmentStatus.SYSTEM_FAILURE,
              })
            );
          })
        );
      }),
      catchError((err: HttpErrorResponse) => {
        return of(
          enrollMileagePlanMemberFailure({
            statusCode: HttpStatusCode.INTERNAL_SERVER_ERROR,
            exceptionContent: err.message,
            mileagePlanEnrollmentStatus: MileagePlanEnrollmentStatus.SYSTEM_FAILURE,
          })
        );
      })
    )
  );
}
